import { sha256 } from 'js-sha256';

export function encryptTextSHA256(text: string): string {
    try {
        return sha256(text.trim().toLowerCase());
    } catch (error) {
        return '';
    }
}
